import { useState, useEffect, useRef, Fragment } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Alert from "../utils/Alert";
import styles from "../../assets/scss/Navbar.module.scss";
import ResetPassword from "../resetPassword/ResetPassword";
import { isEmpty } from "lodash";
import logo from "../../assets/images/logo.png";
import mini_logo from "../../assets/images/mini-logo.png";
import DropdownMenu from "../DropdownMenu/DropdownMenu";
import Notification from "../Notification/Notification";
import Logout from "../Logout/Logout";
import authactions from "../../redux/auth/actions";
import { useDispatch, useSelector } from "react-redux";
import { twoDigitDecimal } from "../../helpers/commonFunction";

const { getUserDataByToken } = authactions;

function Header() {
  const dispatch = useDispatch();
  const [openNotification, setOpenNotification] = useState(true);
  const [toggle, setToggle] = useState(false);
  const [navIsOpen, setNavIsOpen] = useState(null);
  const [openUser, setOpenUser] = useState(true);
  const [logoutModal, setLogoutModal] = useState(false);
  const [resetModal, setResetModal] = useState(false);

  let dropRef = useRef();
  const { tokenData, tokenError, defaultCurrency } = useSelector((state) => state.auth);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropRef.current && !dropRef.current.contains(event.target)) {
        setOpenNotification(true); // close notification
        setLogoutModal(false); // close logout
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    dispatch(getUserDataByToken());
  }, []);

  const navItems = [
    {
      name: "Dashboard",
      path: "/",
      icon: "fa fa-dashboard",
    },
    {
      name: "Admin",
      path: "/",
      icon: "fas fa-user-shield",
      children: [
        {
          name: "Dealer",
          path: "admin/dealer",
          icon: "fas fa-user-tie",
        },
        {
          name: "User",
          path: "admin/user",
          icon: "fas fa-users",
        },
      ],
    },
    {
      name: "Inventory",
      path: "/",
      icon: "fas fa-random",
      children: [
        {
          name: "Purchase SIM",
          path: "inventory/purchase-sim",
          icon: "ri-shopping-cart-fill fs-6",
        },
        {
          name: "Inventory Transfer",
          path: "/inventory/inventory-transfer",
          icon: "fas fa-exchange-alt",
        },
        {
          name: "SIM List",
          path: "/inventory/sim-list",
          icon: "ri-sim-card-line fs-6",
        },

        {
          name: "Purchase SIM List",
          path: "/inventory/purchase-sim-list",
          icon: "ri-sim-card-2-fill fs-6",
        },
      ],
    },
    {
      name: "Activation",
      path: "/",
      icon: "fa-solid fa-sim-card",
      children: [
        {
          name: "SIM Activation",
          path: "activation/sim-activation",
          icon: "fas fa-sim-card",
        },
        {
          name: "Bulk Activation",
          path: "activation/bulk-activation",
          icon: "fas fa-layer-group",
        },
      ],
    },
    {
      name: "Recharge",
      path: "/",
      icon: "fas fa-bolt",
      children: [
        {
          name: "Recharge",
          path: "/recharge/single-recharge",
          icon: "fas fa-wallet",
        },
        {
          name: "Bulk Recharge",
          path: "/recharge/bulk-recharge",
          icon: "fas fa-layer-group",
        },
      ],
    },
    {
      name: "Reports",
      path: "/",
      icon: "fas fa-chart-bar",
      children: [
        {
          name: "Activation Report",
          path: "/reports/activation-report",
          icon: "fas fa-check-circle",
        },
        {
          name: "Recharge Report",
          path: "/reports/recharge-report",
          icon: "fas fa-wallet",
        },
        {
          name: "MSISDN Swap Report",
          path: "/reports/mdn-swap-report",
          icon: "fas fa-exchange-alt",
        },
        {
          name: "SIM Swap Report",
          path: "/reports/sim-swap-report",
          icon: "fas fa-sim-card",
        },
        {
          name: "Batch Activation Report",
          path: "/reports/batch-activation-report",
          icon: "fas fa-layer-group",
        },
        {
          name: "Batch Recharge Report",
          path: "/reports/batch-recharge-report",
          icon: "fas fa-layer-group",
        },
        {
          name: "Wi-Fi Batch Report",
          path: "/reports/wifi-batch-report",
          icon: "fas fa-wifi",
        },
      ],
    },
    {
      name: "Wi-Fi Calling",
      path: "/",
      icon: "fas fa-phone-volume",
      children: [
        {
          name: "Wi-Fi Activation",
          path: "wifi/wifi-activation",
          icon: "fas fa-wifi",
        },
        {
          name: "Cancel Wi-Fi",
          path: "wifi/cancel-wifi",
          icon: "fas fa-ban",
        },
      ],
    },
    {
      name: "Swap",
      path: "/",
      icon: "fas fa-retweet",
      children: [
        {
          name: "MSISDN Swap",
          path: "swap/mdn-swap",
          icon: "fas fa-exchange-alt",
        },
        {
          name: "SIM Swap",
          path: "swap/sim-swap",
          icon: "fas fa-sync-alt",
        },
      ],
    },
    {
      name: "Check Status",
      path: "/",
      icon: "fas fa-tasks",
      children: [
        {
          name: "Check Status",
          path: "checkstatus/check-status",
          icon: "fas fa-info-circle",
        },
        {
          name: "Portin Check Status",
          path: "checkstatus/portin-check-status",
          icon: "fas fa-tasks",
        },
      ],
    },
  ];



  return (
    <>
      <Fragment>
        <div className={`${styles.navbar_wrapper} fixed-top bg-white p-0 flex-column`}>
          <div
            className={`${styles.header_action} d-flex align-items-center justify-content-between h-fixed`}
          >
            <div
              className={styles.navbar_nav}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <div className={styles.logo_container}>
                <button type="button" onClick={() => setToggle(!toggle)}>
                  {toggle ? (
                    <i className="fa-solid fa-xmark"></i>
                  ) : (
                    <i className="fa-solid fa-bars"></i>
                  )}
                </button>
                <Link to="/">
                  <img className={styles.logo} src={logo} alt="logo" />
                  <img
                    className={styles.mini_logo}
                    src={mini_logo}
                    alt="logo"
                  />
                </Link>
              </div>
              <div
                className={styles.logo}
                style={{
                  padding: "7px 18px",
                  borderRadius: "20px",
                  marginLeft: "30px",
                  backgroundColor: "#d8e8dc",
                  color: "#c10ed8",
                  stifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <i className="ri-user-fill fs-6"></i> &nbsp;&nbsp;
                <span style={{ fontWeight: "600", fontSize: "14px" }}>
                  #{tokenData?.aCode}
                </span>{" "}
              </div>
            </div>

            <ul className={styles.social_item} ref={dropRef}>
              <li>
                <p
                  className={styles.logo}
                  style={{
                    color: "#810b90",
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  Account Balance:{" "}
                  <span
                    style={{
                      color: "#48985d",
                      fontWeight: "800",
                      fontSize: "15px",
                    }}
                  >
                    {defaultCurrency} {twoDigitDecimal(tokenData?.accountBalance)}
                  </span>
                </p>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => {
                    setOpenNotification(!openNotification);
                    setLogoutModal(false);
                  }}
                  className={`${styles.for_notification} head-button`}
                  style={{
                    borderRadius: "5px",
                    color: "#fff",
                    margin: "0px 0px 0px 5px",
                    boxShadow: "0px 3px 5px rgba(66, 66, 66, 0.59)",
                    padding: "2px 8px",
                    background: "#ffffff",
                  }}
                >
                  <i className="fas fa-phone"></i>
                </button>
                {!openNotification ? (
                  <DropdownMenu left="24px" right="24px">
                    <Notification />
                  </DropdownMenu>
                ) : null}
              </li>

              <li>
                <button
                  type="button"
                  onClick={() => {
                    setResetModal(true);
                    setLogoutModal(false);
                    setOpenNotification(true);
                  }}
                  className={styles.for_message}
                  style={{
                    borderRadius: "5px",
                    color: "#fff",
                    margin: "0px 0px 0px 5px",
                    boxShadow: "0px 3px 5px rgba(66,66,66,.59)",
                    padding: "2px 8px",
                    background: "#ffffff",
                  }}
                >
                  <i className="ri-user-fill"></i>
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => {
                    setLogoutModal(prev => !prev);
                    setOpenNotification(true);
                  }}
                  className={styles.for_message}
                  style={{
                    borderRadius: "5px",
                    color: "#fff",
                    margin: "0px 0px 0px 5px",
                    boxShadow: "0px 3px 5px rgba(66, 66, 66, 0.59)",
                    padding: "2px 8px",
                    background: "#ffffff",
                  }}
                >
                  <i className="ri-shut-down-line " style={{ fontWeight: "600" }}></i>
                </button>

                {/* Logout Modal */}
                <Logout setLogoutModal={setLogoutModal} showlogoutModal={logoutModal} />
              </li>
            </ul>
            <ResetPassword onCloseModal={() => setResetModal(false)} showResetModal={resetModal} />
          </div>

          {/* Nav Items */}
          <div
            data-color={"black"}
            className={`${styles.duall_navbar} ${toggle ? styles.toggle_menu : ""
              }`}
          >
            <ul className={`${styles.nav}`}>
              {navItems?.map((item, index) => (
                <li
                  key={index}
                  className={`${styles.nav_item} ${item.title ? "d-none" : ""}`}
                >
                  {(item?.path && (
                    <Fragment>
                      {isEmpty(item?.children) ? (
                        <Link
                          to={item?.path}
                          {...(item?.target && {
                            target: "_blank",
                          })}
                          onClick={() =>
                            setNavIsOpen(navIsOpen === index ? null : index)
                          }
                          className="d-flex justify-content-between align-items-center"
                        >
                          <div className="d-flex align-items-center gap-2">
                            <i className={`${item.icon} menu-icon`}></i>
                            <span>{item.name}</span>
                          </div>
                        </Link>
                      ) : (
                        <a
                          onClick={() =>
                            setNavIsOpen(navIsOpen === index ? null : index)
                          }
                          className="d-flex justify-content-between align-items-center user-select-none "
                        >
                          <div className="d-flex align-items-center gap-2">
                            <i className={`${item.icon} menu-icon`}></i>
                            <span>{item.name}</span>
                          </div>
                        </a>
                      )}
                    </Fragment>
                  )) ||
                    (item?.url && (
                      <a
                        href={item?.url}
                        target="_blank"
                        className="d-flex align-items-center"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <i className={`${item.icon} menu-icon`}></i>
                          <span>{item.name}</span>
                        </div>
                      </a>
                    ))}
                  {item.children ? (
                    <ul className={styles.sub_menu}>
                      {item?.children?.map((childItem, index) => (
                        <li key={index}>
                          <NavLink
                            to={childItem?.path}
                            className={({ isActive }) =>
                              `d-flex justify-content-between align-items-center ${isActive ? styles.activeSubMenu : ""
                              }`
                            }
                          >
                            <div className="d-flex align-items-center gap-2">
                              <i className={`${childItem.icon} menu-icon`}></i>
                              <span>{childItem.name}</span>
                            </div>
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  ) : null}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Fragment>
    </>
  );
}

export default Header;
